import React from 'react'

const Empty = () => {
  return (
   <div style={{textAlign:"center"}}>
        <h1>YOUR CART IS EMPTY!!</h1>
        <img src='https://cdn3.iconfinder.com/data/icons/shopping-and-ecommerce-28/90/empty_cart-512.png'/>
   </div>
  )
}

export default Empty